export default {
  dataModel: {
    types: ['cdlt:OfferAndNeedTemplate'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};